<template>
  <div class="partner">
    <div class="partner-line">
      <picture class="imac-bg">
        <source
          :srcset="require(`@/assets/img/partners/${partner.imgUrl}`)"
          type="image/webp"
        />
        <img
          class="partner-photo"
          alt="partners sovtes"
          :src="require(`@/assets/img/partners/${partner.imgClassicUrl}`)"
        />
      </picture>
    </div>

    <p class="partner-line partner-only text-b uppercase" v-if="partner.only">
      {{ title }}
    </p>

    <div class="partner-line text-sm">
      <p
        v-for="line in partner.description"
        :key="line"
        v-html="line"
        class="partner-text"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    partner: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.partner {
  min-height: 320px;

  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin: 0 auto;
  line-height: 1.5;

  &-only {
    font-weight: 500;
  }

  &-line {
    margin: 10px 0;
    text-align: left;
  }

  &-text {
    padding: 10px 0;
    text-align: center;
  }

  &-photo {
    max-width: 250px;
  }
}
</style>
